<template>
    <section id="Contact">
      <div class="container my-5"  data-aos="fade-up" data-aos-duration="3000">
        <div class="row pb-0 pe-lg-0 pt-lg-5 align-items-center rounded-3 border shadow-lg">
          <div class="col-md-6">
            <div class="p-5">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7817.831121599908!2d104.86077370906588!3d11.557910880374187!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x310951c66d00795b%3A0xd057dee528c2bcab!2sMinistry+of+Commerce!5e0!3m2!1sen!2ssg!4v1449762618271" width="100%" height="300" frameborder="0" style="border:0" ></iframe>
            </div>
          </div>
          <div class="col-md-6">
            <div class="p-5">
              <h2 class="display-5 fw-bold">Contact</h2>
              <p class="lead">Contact us now for advice from our experts on suitable technologies,legal form, requirements, and rights and obligations of your business startup.</p>
              <p class="lead">Email: <a href="mailto:somsothea@gmail.com">somsothea@gmail.com</a><br>
                Tel:   +855 70 606 004</p>
              <a href="tel:+85570606004"><button type="button" class="btn btn-primary btn-lg px-4 me-md-2">Call Now</button></a>
            </div>
          </div>
        </div>
      </div>
    </section>
</template>